import React from 'react';
import PropTypes from 'prop-types';
import Rates from './Rates';
import Api from '../../Api';
import InterfaceStorage from '../Site/InterfaceStorage';
import sm from '../../StorageManager';

export default class RatesComponent extends React.Component {

    constructor(props) {

        super(props);

        this.components = {
            rates: React.createRef(),
        };
    }

    static get propTypes() {

        return {
            i18nLink: PropTypes.string.isRequired,
        };
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    render() {

        const
            countrySlug = document.body.dataset.geoCountry,
            citySlug = document.body.dataset.geoCity;

        if (!countrySlug)
            throw new Error('Data param "geoCountry" is required');

        Promise
            .allSettled([
                Api.fetch(`${Api.origin}/api/v2/price/offer.json?country=${countrySlug}&city=${citySlug}&slug=Mortgage Interest Rate`),
                Api.fetch(`${Api.origin}/api/v2/price/offer.json?country=${countrySlug}&city=${citySlug}&slug=Annual Mortgage Interest Rate`),
                sm.getFrom(this.props.i18nLink),
            ])
            .then(([interest, apr]) => {
                
                const tabs = this.components.rates.current.components.tabs.current;
                this.processingInterest(interest, tabs);
                this.processingAPR(apr, tabs);
                this.processingI18n();
            });

        return <Rates ref={ this.components.rates } />;
    }

    //------------------------------------------------------------------------------------------------------------------
    // PROCESSING
    //------------------------------------------------------------------------------------------------------------------

    processingInterest(interest, tabs) {

        if (interest.status != 'rejected' && interest.value.min != interest.value.avg != interest.value.max != 0) {

            InterfaceStorage
                .getComponent('ratesAnalysisInterestMinValue')
                .setValue(interest.value.min);

            InterfaceStorage
                .getComponent('ratesAnalysisInterestMaxValue')
                .setValue(interest.value.max);

            InterfaceStorage
                .getComponent('ratesAnalysisInterestAvgValue')
                .setValue(interest.value.avg);
        }
        else {

            tabs.remove('analysisInterestTab');
        }
    }

    processingAPR(apr, tabs) {

        if (apr.status != 'rejected' && apr.value.min != apr.value.avg != apr.value.max != 0) {

            InterfaceStorage
                .getComponent('ratesAnalysisAPRMinValue')
                .setValue(apr.value.min);
                
            InterfaceStorage
                .getComponent('ratesAnalysisAPRMaxValue')
                .setValue(apr.value.max);

            InterfaceStorage
                .getComponent('ratesAnalysisAPRAvgValue')
                .setValue(apr.value.avg);
        }
        else {

            tabs.remove('analysisAPRTab');
        }
    }

    processingI18n() {

        Object
            .entries(this.mappingI18n())
            .forEach(([key, uid]) => {

                const component = InterfaceStorage.getComponent(uid, InterfaceStorage.COUNTRY);
                if (component)
                    component.setValue(sm.get(InterfaceStorage.COUNTRY, key, false, false));
            });

        const rates = sm.get(InterfaceStorage.COUNTRY, 'calculatorAnalysisItems', true);

        [
            'ratesAnalysisInterestMinLabel',
            'ratesAnalysisInterestMaxLabel',
            'ratesAnalysisInterestAvgLabel',
            'ratesAnalysisAPRMinLabel',
            'ratesAnalysisAPRMaxLabel',
            'ratesAnalysisAPRAvgLabel',
        ].forEach((name) => {

            const component = InterfaceStorage.getComponent(name, InterfaceStorage.COUNTRY);
            if (component)
                component.setValue(rates[0].text);
        });

        const apply =
            this.getFromStorage(InterfaceStorage.CALCULATOR, 'mortgageAnalysisOfferButton') ??
            this.getFromStorage(InterfaceStorage.AGGREGATION_CATEGORY, 'mortgageAnalysisOfferButton') ??
            this.getFromStorage(InterfaceStorage.COUNTRY, 'mortgageAnalysisOfferButton');

        InterfaceStorage
            .getComponent('ratesCompareApply', [
                InterfaceStorage.CALCULATOR,
                InterfaceStorage.AGGREGATION_CATEGORY,
                InterfaceStorage.COUNTRY,
            ])
            .setValue(apply);
    }

    getFromStorage(storage, id) {

        const values = Object
            .entries(sm.get(storage, id, true, false) ?? {})
            .filter(([key, value]) => {

                return !!value;
            });

        return values.length > 0
            ? Object.fromEntries(values)
            : null;
    }

    mappingI18n() {

        return {
            'calculatorAnalysisTitle': 'ratesAnalysisTitle',
            'calculatorAnalysisText': 'ratesAnalysisSubTitle',
            'mortgageAnalysisOfferCompanyName': 'ratesCompareTitle',
            'mortgageAnalysisOfferCompanyImage': 'ratesCompareIcon',
            'mortgageAnalysisOfferSubtitle': 'ratesCompareSubTitle',
            'mortgageAnalysisOfferRate': 'ratesComparePercent',
            'mortgageAnalysisOfferProfit': 'ratesComparePercentDiff',
            'mortgageAnalysisReadMorePopup': 'analysisReadMorePopup',
            'mortgageAnalysisHowToPopup': 'analysisHowToPopup',
            'mortgageAnalysisInterestTab': 'analysisInterestTab',
            'mortgageAnalysisAPRTab': 'analysisAPRTab',
        };
    }
}